<template>
	<ja-modal v-if="message && sender" class="logoutModal" :show="show">
		<content>
			<ja-close-button
				name="close"
				@click.native="markAsRead"
			></ja-close-button>

			<h2 class="title">{{ sender.firstName }} {{ sender.lastName }}</h2>
			<h5 class="message-date">
				{{ message.dateCreated | dateFormat }} /
				{{ message.dateCreated | timeFormat }}
			</h5>
			<div class="message-text body-text-1">
				{{ message.text }}
			</div>
			<div class="button-wrapper">
				<ja-button
					v-if="!isDone"
					class="cancel-button large"
					name="cancel"
					@click.native="markAsDone"
				>
					<span>{{ $t('markAsDone') }}</span>
				</ja-button>
				<ja-button
					class="confirm-button large transparent outlined"
					name="confirm"
					@click.native="openMessageDeletionModal"
				>
					<span>{{ $t('delete') }}</span>
				</ja-button>
			</div>
		</content>
	</ja-modal>
</template>

<script>
import '../icons/arrow-right';
import '../icons/modal-close';
import Button from '../ui/Button';
import Modal from './Modal';
import gql from 'graphql-tag';
import CloseButton from '../ui/CloseButton';

export default {
	components: {
		jaButton: Button,
		jaModal: Modal,
		jaCloseButton: CloseButton
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		message: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			logoutAttempt: false
		};
	},
	computed: {
		sender() {
			if (this.message) {
				if (this.message.sentByStudent) {
					return this.message.sentByStudent;
				}
				return this.message.sentByUser;
			}
			return null;
		},
		isDone() {
			if (this.message) {
				return this.message.messageStatus === 'Done';
			}
			return null;
		}
	},
	methods: {
		closeModal() {
			this.$emit('closeMessageDisplayModal');
		},
		openMessageDeletionModal() {
			this.$emit('openMessageDeletionModal', this.message);
		},
		async markAsDone() {
			this.updateMessageStatus('Done');
			this.closeModal();
		},
		async markAsRead() {
			if (this.message.messageStatus !== 'Done') {
				this.updateMessageStatus('Read');
			}
			this.closeModal();
		},
		async updateMessageStatus(status) {
			const messageStatusUpdate = {
				id: this.message.id,
				messageStatus: status
			};

			const response = await this.$apollo.mutate({
				mutation: gql`
					mutation($update: MessageInputObjectGraphType!) {
						updateMessage(update: $update) {
							id
						}
					}
				`,
				variables: {
					update: messageStatusUpdate
				}
			});
			if (response.data) {
				this.$emit('refetchMessages');
			}
		}
	}
};
</script>
<style lang="scss" scoped>
content {
	padding: 48px;
}

.message-date {
	color: $font-dark;
	font-family: 'RobotoMedium';
	margin-right: 8px;
	text-transform: uppercase;
}

.message-text {
	white-space: pre-line;
	word-break: break-word;
	text-align: left;
	padding-top: 24px;
	@media (min-width: $breakpoint-mid) {
		padding-top: 32px;
	}
}

.cancel-button,
.confirm-button {
	margin-top: 48px;
}

.cancel-button {
	margin-right: 16px;
}
</style>
